import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowDown} = FiIcons;
const headerImage = 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/5eda22a456ab8e9bbd13fd45d1d77bbd.jpeg';

export default function Hero({copy}) {
  return (
    <section
      id="top"
      className="hero"
      style={{backgroundImage: `url("${headerImage}")`}}
    >
      <style>{`
        #top.hero {
          background-position: center;
        }

        @media (max-width: 700px) {
          #top.hero {
            background-position: 75% center;
          }
        }
      `}</style>
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="eyebrow hero-eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <div className="hero-rule" />
        <p className="hero-date">{copy.date}</p>
        <p className="hero-message">{copy.message}</p>
        <a className="button button-light" href="#rsvp">{copy.cta}</a>
      </div>
      <a className="scroll-cue" href="#story">
        <span>{copy.scroll}</span>
        <SafeIcon icon={FiArrowDown} />
      </a>
    </section>
  );
}